var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { CancelButton, SaveButton, } from "../../src/View/UI/StandardButtons/StandardButtons";
import VirtualizedAppService from "../../src/Services/VirtualizedApp.service";
import Busy from "../shared/busy";
import Errors from "../shared/errors";
import AuditData from "../../src/View/UI/AuditData/auditData";
import FAIcon from "../../src/View/UI/FAIcon/FAIcon";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
import RoleService from "../../src/Services/Role.service";
import { getSurveyAdminIndexPath } from "../../src/View/Pages/Admin/Survey/AdminSurveyRoutes";
import { getXSRF } from "../../src/Services/Shared/FetchService";
class SurveyDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            surveyId: props.match.params.surveyId,
            survey: null,
            auditData: null,
            isLoading: false,
            isSaving: false,
            showSaveSuccess: false,
            rolesThatCanSendSurvey: null,
            rolesThatCanViewSurveyResults: null,
            availableRoles: null,
            appsThatCanViewSurvey: null,
            errors: [],
        };
        // @ts-expect-error - TS2339 - Property 'loadAppsPromise' does not exist on type 'SurveyDetail'.
        this.loadAppsPromise = [];
        // @ts-expect-error - TS2339 - Property 'loadRolesPromise' does not exist on type 'SurveyDetail'.
        this.loadRolesPromise = this.loadRoles();
        // @ts-expect-error - TS2339 - Property 'loadRolesPromise' does not exist on type 'SurveyDetail'.
        this.loadRolesPromise.then(() => {
            // @ts-expect-error - TS2339 - Property 'loadAppsPromise' does not exist on type 'SurveyDetail'.
            this.loadAppsPromise = this.loadApps();
            this.getSurvey();
        });
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSyncEnabledChange = this.handleSyncEnabledChange.bind(this);
        this.handleIsKeyEngagementChange =
            this.handleIsKeyEngagementChange.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.onSendRolesChange = this.onSendRolesChange.bind(this);
        this.onViewResultsRolesChange = this.onViewResultsRolesChange.bind(this);
        this.onAppAccessChange = this.onAppAccessChange.bind(this);
    }
    getSurvey() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ isLoading: true });
                const { survey, rolesThatCanSend, rolesThatCanViewResults, appsThatCanViewSurvey, auditData, } = yield this.fetchSurvey();
                this.setState({
                    survey,
                    auditData,
                    rolesThatCanSendSurvey: rolesThatCanSend,
                    rolesThatCanViewSurveyResults: rolesThatCanViewResults,
                    appsThatCanViewSurvey,
                    isLoading: false,
                });
            }
            catch (e) {
                this.setState({
                    errors: [
                        ...this.state.errors,
                        `There was a problem loading the survey.\n${e}`,
                    ],
                    isLoading: false,
                });
            }
        });
    }
    fetchSurvey() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/surveyAdmin/survey?id=${this.state.surveyId}`, {
                credentials: "include",
            });
            const result = yield response.json();
            return result.data;
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    handleNameChange(event) {
        const { target } = event;
        this.setState({
            survey: Object.assign(this.state.survey, {
                displayName: target.value,
            }),
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    handleSyncEnabledChange(event) {
        const { target } = event;
        this.setState({
            survey: Object.assign(this.state.survey, {
                syncEnabled: target.checked,
            }),
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    handleIsKeyEngagementChange(event) {
        const { target } = event;
        this.setState({
            survey: Object.assign(this.state.survey, {
                isKeyEngagement: target.checked,
            }),
        });
    }
    handleSaveClick() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({
                    isSaving: true,
                    showSaveSuccess: false,
                });
                if (!((_a = this.state.survey) === null || _a === void 0 ? void 0 : _a.displayName)) {
                    this.setState({
                        errors: ["Name is required"],
                        isSaving: false,
                    });
                }
                else {
                    const result = yield this.saveSurvey();
                    if (!result.success) {
                        this.setState({
                            errors: [
                                ...this.state.errors,
                                "There was a problem saving the survey.",
                            ],
                        });
                    }
                    this.setState({
                        isSaving: false,
                        showSaveSuccess: result.success,
                    });
                    this.getSurvey();
                }
            }
            catch (e) {
                this.setState({
                    errors: [
                        ...this.state.errors,
                        `There was a problem saving the survey.\n${e}`,
                    ],
                    isSaving: false,
                });
            }
        });
    }
    saveSurvey() {
        return __awaiter(this, void 0, void 0, function* () {
            const requestBodyObject = Object.assign(Object.assign({}, this.state.survey), { 
                // @ts-expect-error - TS7006 - Parameter 'r' implicitly has an 'any' type.
                sendSurveyRoleIds: this.state.rolesThatCanSendSurvey.map((r) => r.id), viewResultsRoleIds: this.state.rolesThatCanViewSurveyResults.map(
                // @ts-expect-error - TS7006 - Parameter 'r' implicitly has an 'any' type.
                (r) => r.id), appsThatCanViewSurveyIds: this.state.appsThatCanViewSurvey.map(
                // @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
                (a) => a.id) });
            const response = yield fetch(`/aviso/surveyAdmin/updateSurvey?id=${this.state.surveyId}`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify(requestBodyObject),
            });
            return response.json();
        });
    }
    loadRoles() {
        return __awaiter(this, void 0, void 0, function* () {
            return RoleService.search().then((response) => ({
                options: response.data,
            }));
        });
    }
    loadApps() {
        return __awaiter(this, void 0, void 0, function* () {
            return VirtualizedAppService.getInternalApps().then((response) => ({
                // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'VirtualizedApp[]'.
                options: response.data,
            }));
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    onSendRolesChange(value) {
        this.setState({ rolesThatCanSendSurvey: value });
    }
    // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    onViewResultsRolesChange(value) {
        this.setState({ rolesThatCanViewSurveyResults: value });
    }
    // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    onAppAccessChange(value) {
        this.setState({ appsThatCanViewSurvey: value });
    }
    render() {
        const { history } = this.props;
        return (_jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block", children: _jsxs("h1", { className: "title", children: [_jsx(Link, { className: "mr-2", to: getSurveyAdminIndexPath(), title: "Back to survey list", children: _jsx(FAIcon, { addMarginRight: true, icon: "arrow-circle-left" }) }), "Edit Survey", _jsx("span", { className: "ml-2", children: _jsx(Busy, { isBusy: this.state.isLoading }) })] }) }), this.state.showSaveSuccess && (_jsxs("div", { className: "alert alert-success", children: [_jsx("span", { "aria-hidden": "true", className: "fa fa-check-circle" }), " Survey saved!"] })), _jsx(Errors, { errors: this.state.errors }), this.state.survey && (_jsxs("div", { children: [_jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "surveyDetailName", children: "Name" }), _jsx("div", { children: _jsx("input", { id: "surveyDetailName", className: "form-control", onChange: this.handleNameChange, type: "text", value: this.state.survey.displayName }) })] }), _jsxs("div", { className: "form-group", children: [_jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { id: "sync-enabled", checked: this.state.survey.syncEnabled, className: "custom-control-input", onChange: this.handleSyncEnabledChange, type: "checkbox" }), _jsx("label", { className: "custom-control-label", htmlFor: "sync-enabled", children: "Sync Enabled" })] }), _jsx("small", { className: "text-muted", children: "When checked, survey responses will be automatically pulled into Aviso Engage. This is performed by a job that checks for new or modified survey responses every 20 minutes." })] }), _jsxs("div", { className: "form-group", children: [_jsxs("div", { className: "custom-control custom-checkbox", children: [_jsx("input", { id: "is-key-engagement", checked: this.state.survey.isKeyEngagement, className: "custom-control-input", onChange: this.handleIsKeyEngagementChange, type: "checkbox" }), _jsx("label", { className: "custom-control-label", htmlFor: "is-key-engagement", children: "Is Key Engagement" })] }), _jsx("small", { className: "text-muted", children: "When checked, identifies whether the completion of this survey by a student is considered a Key Engagement." })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { className: "control-label", htmlFor: "rolesThatCanSendSurvey", children: "Roles that can Send this Survey" }), _jsx("div", { children: _jsx(DeprecatedSelect.Async, { id: "rolesThatCanSendSurvey", "aria-label": "Roles that can Send this Survey", labelKey: "name", loadOptions: (search) => RoleService.search({ name: search, isDeleted: false }, { max: 10 }).then((resp) => ({
                                            options: resp.data,
                                        })), multi: true, onChange: this.onSendRolesChange, value: this.state.rolesThatCanSendSurvey, valueKey: "id" }) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { className: "control-label", htmlFor: "rolesThatCanViewSurveyResults", children: "Roles that can View this Survey's Results" }), _jsx("div", { children: _jsx(DeprecatedSelect.Async, { id: "rolesThatCanViewSurveyResults", "aria-label": "Roles that can View this Survey's Results", labelKey: "name", loadOptions: (search) => RoleService.search({ name: search, isDeleted: false }, { max: 10 }).then((resp) => ({
                                            options: resp.data,
                                        })), multi: true, onChange: this.onViewResultsRolesChange, value: this.state.rolesThatCanViewSurveyResults, valueKey: "id" }) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { className: "control-label", htmlFor: "appsWithAccessToSurvey", children: "Associated Apps" }), _jsx("div", { children: _jsx(DeprecatedSelect.Async, { id: "appsWithAccessToSurvey", "aria-label": "Apps that can View this Survey", labelKey: "displayName", 
                                        // @ts-expect-error - TS2339 - Property 'loadAppsPromise' does not exist on type 'SurveyDetail'.
                                        loadOptions: () => this.loadAppsPromise, multi: true, onChange: this.onAppAccessChange, value: this.state.appsThatCanViewSurvey, valueKey: "id" }) })] }), _jsx(AuditData, { hideHorizontalRule: true, createdBy: this.state.auditData.createdBy, createdDate: new Date(this.state.auditData.createdDate), modifiedBy: this.state.auditData.modifiedBy, modifiedDate: new Date(this.state.auditData.modifiedDate) }), _jsx(SaveButton, { className: "mr-1", isLoading: this.state.isSaving, onClick: this.handleSaveClick }), _jsx(CancelButton, { onClick: () => {
                                history.push(getSurveyAdminIndexPath());
                            } })] }))] }));
    }
}
export default withRouter(SurveyDetail);
